var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.935 8.29471C10.935 7.69288 11.4235 7.20448 12.0252 7.20448C12.627 7.20448 13.1155 7.69288 13.1155 8.29471C13.1155 8.89644 12.627 9.38493 12.0252 9.38493C11.4234 9.38493 10.935 8.89644 10.935 8.29471ZM12.0252 5.46002C10.4595 5.46002 9.19054 6.72919 9.19054 8.29471C9.19054 9.86023 10.4595 11.1294 12.0252 11.1294C13.5907 11.1294 14.8599 9.86028 14.8599 8.29471C14.8599 6.72919 13.5907 5.46002 12.0252 5.46002ZM5.26562 8.1725C5.26562 12.6208 10.5119 16.0441 10.935 21.1598V21.3779C10.935 21.9796 11.4235 22.468 12.0252 22.468C12.627 22.468 13.1155 21.9796 13.1155 21.3779V21.1598C13.5643 16.0441 18.7847 12.6208 18.7847 8.1725C18.7847 4.50496 15.7586 1.53516 12.0252 1.53516C8.29217 1.53511 5.26562 4.50496 5.26562 8.1725ZM12.0252 3.71556C14.5545 3.71556 16.6042 5.7654 16.6042 8.29466C16.6042 10.824 14.5545 12.8738 12.0252 12.8738C9.49591 12.8738 7.44612 10.824 7.44612 8.29466C7.44612 5.7654 9.49591 3.71556 12.0252 3.71556Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.7aa87bc661e29a8f99162a5883c4d8f8.svg";
export { ForwardRef as ReactComponent };